import { inject, Injectable } from '@angular/core';
import { catchError, map, type Observable, of } from 'rxjs';
import { toDataResult, ToResult } from '@team23/ts-result';
import {
    FilterConfigService,
    type FilterDataResult,
    FilterDataStatus,
    MultiFilterModel,
} from '@ui/shared/util-filter';
import {
    PreventionListService,
} from '@ui/shared/util-api';
import type { PreventionListFilterKey } from '../../types/prevention-list-filters';

@Injectable({ providedIn: 'root' })
export class AgeGroupSelectFilterConfigService extends FilterConfigService<PreventionListFilterKey, PreventionListService> {

    constructor() {
        super(
            new MultiFilterModel('ageGroups', 'Altersgruppen', []),
            inject(PreventionListService),
        );
    }

    protected _getOptions$(): Observable<FilterDataResult> {
        return this._api.getAllPreventionListAgeGroups({
            order: [],
        })
            .pipe(
                map(result =>
                    result.data.map(dto => ({
                        value: dto.id,
                        label: dto.name,
                    })),
                ),
                toDataResult(),
                catchError(() => of(ToResult.fromErrorKey(FilterDataStatus.Generic))),
            );
    }
}
